import axios from "axios";

import { IOtpRequest, IUserOtp } from "models/Otp/otp.model";
import { store } from "redux/store";
import { RSAEncrypt } from "utils/CryptOperations/Rsa-encrypt";
import { IgsEnc } from "utils/gmuCrypto";

export const Otp = async (otpParams: IOtpRequest): Promise<IUserOtp> => {
  const reduxStore = store.getState();

  otpParams.corporateIndividual = reduxStore.login.user?.corporateOrIndividual;
  otpParams.phoneNumber =
    reduxStore.login.user?.mbb_phoneNumber ||
    reduxStore.PassRefCardInfo.cardInfo?.DefaultPhone;
  otpParams.TokenSessionId =
    reduxStore.login.user?.tokenSessionID ||
    reduxStore.login.user?.TokenSessionId ||
    reduxStore.PassRefPersonelInfo.passwordInfo?.TokenSessionId;
  const reqData = serviceOtpModelCreator(otpParams);

  try {
    const { data } = await axios.post<IUserOtp>("/Token", reqData);

    if (data.DialogBoxes.length > 0)
      throw data.ErrorCode + "#" + data.DialogBoxes[0].Message;

    return data;
  } catch (error) {
    console.log(`OTP_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceOtpModelCreator = (otpParams: IOtpRequest) => {
  let req = {};
  if (otpParams.fromGetPassword) {
    req = {
      OtpEnc: RSAEncrypt(otpParams.otpRefNo!),
      NextTransactionUrl: "ModAuthAndroidPosPassForgetComplate",
      TokenSessionId: otpParams.TokenSessionId,
      // Mbb: null,
      // OtpEnc: RSAEncrypt(otpParams.otpRefNo!),
      // TokenSessionId: otpParams.TokenSessionId,
      // SmsOtpId: otpParams.SmsOtpId,
      // androidUID: null,
      // carrier: null,
      // changeKey: null,
      // ChannelKey: null,
      // clientDeviceID: null,
      // ClientUid: null,
      // connectionType: null,
      // DeviceBrand: null,
      // DeviceModel: null,
      // deviceOs: null,
      // deviceOsType: null,
      // DeviceOsVersion: null,
      // deviceType: null,
      // deviceVersion: null,
      // hardOtpFlag: false,
      // imei: null,
      // isCracked: null,
      // softOtpFlag: null,
      // kullAdiEnc: null,
      // userAgent: null,
      // CallbackFunctionId: null,
      // isBusy: false,
      // isNativeFlag: "true",
      // Language: "tr-TR",
      // igsEnc: null,
      // NextTransactionUrl: "ModAuthNativePassForgetVerifyOtp",
    };
  } else if (otpParams.corporateIndividual === "2") {
    req = {
      Mbb: otpParams.phoneNumber,
      OtpEnc: RSAEncrypt(otpParams.otpRefNo!),
      TokenSessionId: otpParams.TokenSessionId,
      SmsOtpId: otpParams.SmsOtpId,
      androidUID: null,
      carrier: null,
      changeKey: null,
      ChannelKey: null,
      clientDeviceID: null,
      ClientUid: null,
      connectionType: null,
      DeviceBrand: null,
      DeviceModel: null,
      deviceOs: null,
      deviceOsType: null,
      DeviceOsVersion: null,
      deviceType: null,
      deviceVersion: null,
      hardOtpFlag: false,
      imei: null,
      isCracked: null,
      softOtpFlag: null,
      kullAdiEnc: null,
      userAgent: null,
      CallbackFunctionId: null,
      isBusy: false,
      isNativeFlag: "true",
      Language: "tr-TR",
      igsEnc: null,
      NextTransactionUrl: "ModAuthWebComplete", //"ModAuthPosComplete",
    };
  } else {
    // kurumsal
    req = {
      Mbb: null,
      OtpEnc: RSAEncrypt(otpParams.otpRefNo!),
      TokenSessionId: otpParams.TokenSessionId,
      SmsOtpId: otpParams.SmsOtpId,
      androidUID: null,
      carrier: null,
      changeKey: null,
      ChannelKey: null,
      clientDeviceID: null,
      ClientUid: null,
      connectionType: null,
      DeviceBrand: null,
      DeviceModel: null,
      deviceOs: null,
      deviceOsType: null,
      DeviceOsVersion: null,
      deviceType: null,
      deviceVersion: null,
      hardOtpFlag: false,
      imei: null,
      isCracked: null,
      softOtpFlag: null,
      kullAdiEnc: null,
      userAgent: null,
      CallbackFunctionId: null,
      isBusy: false,
      isNativeFlag: "true",
      Language: "tr-TR",
      igsEnc: null,
      NextTransactionUrl: "ModAuthCorpWebComplete", //"ModAuthCorpMobComplete",
    };
  }

  return req;
};
